import cx from 'clsx';

type Props = {
  className?: string;
};

export default function LegalNotice({ className }: Props) {
  return (
    <article
      className={cx(
        'flex items-center px-20 py-16 typo-footnote300-regular text-hint',
        className,
      )}
    >
      (주)한국신용데이터는 통신판매중개자로서 통신판매의 당사자가 아니며 상품의
      주문, 배송 및 환불 등과 관련한 의무와 책임은 각 판매자에게 있습니다.
      <br />
      마켓플레이스는 사업자간 상행위를 목적으로 하는 통신판매중개 플랫폼으로서,
      전자상거래법이 적용되지 않습니다. 단, (주)한국신용데이터가 판매자로 등록
      판매한 상품은 판매자로서 책임을 부담합니다.
    </article>
  );
}
